import PrimaryButton from '../../../../Commons/Buttons/PrimaryButton'
import {
    Copy,
    DataTransferBoth,
    NavArrowDown,
    Printer,
    FloppyDiskArrowIn,
} from 'iconoir-react'
import React from 'react'
import {
    findValueByStatus,
    findColorByStatusType,
} from '../../../Invoice/Cpam/InvoiceCpamListComponent'
import SecondaryButton from '../../../../Commons/Buttons/SecondaryButton'

export const InvoiceStatusDisplay = ({ invoice, handleSuspendedInvoice }) => {
    const totalAmount = parseFloat(invoice.totals.totalAmount?.toFixed(2))
    const difference = Math.abs(totalAmount - invoice.totalInvoiceAmount)

    const checkIfRateChanged =
        invoice.totals.totalAmo?.toFixed(2) ===
        invoice.payingCenterAmount?.toFixed(2)

    if (!invoice.id) {
        return (
            <>
                <h1 className="pr-2 text-2xl font-semibold">Facturation</h1>
                <p>Transformez votre transport en facture</p>
            </>
        )
    }

    if (invoice.status?.label === 'Rejetée') {
        return (
            <div
                className="w-full rounded-b border-t-4 border-red-500 bg-red-100 px-4 py-3 text-red-600 shadow-md"
                role="alert"
            >
                <div className="flex items-center">
                    <DataTransferBoth className="mr-4" />
                    <div>
                        <p className="text-xl font-semibold">Rejetée</p>
                        <p className="text-md">{invoice.rejectionReason}</p>
                    </div>
                </div>
            </div>
        )
    }

    if ((difference !== 0 && difference >= 0.01) || !checkIfRateChanged) {
        return (
            <>
                <div className={'flex space-x-4 pb-4'}>
                    <span
                        className={`flex items-center justify-center rounded-full px-2 py-1 text-xl ${findColorByStatusType(
                            invoice.status
                        )}`}
                    >
                        {findValueByStatus(invoice.status)}
                    </span>
                    {invoice.id && invoice?.status?.label === 'Créée' ? (
                        <SecondaryButton
                            label={'Suspendre'}
                            action={handleSuspendedInvoice}
                        />
                    ) : invoice.id && invoice?.status?.label === 'Suspendue' ? (
                        <SecondaryButton
                            label={'Autoriser la télétransmission'}
                            action={handleSuspendedInvoice}
                        />
                    ) : null}
                </div>
                <div
                    className="w-full rounded-b border-t-4 border-red-500 bg-red-100 px-4 py-3 text-red-600 shadow-md"
                    role="alert"
                >
                    <div className="flex items-center">
                        <FloppyDiskArrowIn className="mr-4 hidden sm:flex" />
                        <div>
                            <p className="text-xl font-semibold">
                                Enregistrez vos modifications
                            </p>
                            <p className="text-md">
                                Si vous souhaitez confirmer vos modifications,
                                n'oubliez pas de modifier la facture
                            </p>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div className={'flex space-x-4'}>
            <span
                className={`flex items-center justify-center rounded-full px-2 py-1 text-xl ${findColorByStatusType(
                    invoice.status
                )}`}
            >
                {findValueByStatus(invoice.status)}
            </span>
            {invoice.id && invoice?.status?.label === 'Créée' ? (
                <SecondaryButton
                    label={'Suspendre'}
                    action={handleSuspendedInvoice}
                />
            ) : invoice.id && invoice?.status?.label === 'Suspendue' ? (
                <SecondaryButton
                    label={'Autoriser la télétransmission'}
                    action={handleSuspendedInvoice}
                />
            ) : null}
        </div>
    )
}

export const InvoiceActions = ({
    invoice,
    checkAbleToInvoice,
    prescription,
    run,
    checkAndHandleInvoiceForm,
    patient,
    dateOfBirth,
    loading,
}) => {
    if (invoice.id && invoice?.status?.label !== 'Créée') {
        return
        //     return (
        //         <InvoiceActionMenu
        //             invoice={invoice}
        //             dispatch={dispatch}
        //             action={action}
        //         />
        //     )
    }

    return (
        <PrimaryButton
            label={
                invoice.id
                    ? 'Modifier la facture'
                    : !checkAbleToInvoice(
                          patient,
                          invoice,
                          prescription,
                          run,
                          false,
                          dateOfBirth
                      )
                    ? 'Facturer le transport'
                    : 'Verifier les informations'
            }
            loader={loading}
            disabled={loading}
            action={checkAndHandleInvoiceForm}
        />
    )
}
